import instance from '@/api/business'
import { Impediment } from '@/types/Impediment' 
import { DeleteImpedimentProps, UpdateImpedimentProps } from './type'

const BASE_URL = '/impediment/cockpit/impediment'
export const fetchImpediment = async () => {
    const response = await instance.post<Impediment[]>(BASE_URL)

    return response.data
}
 
export const createImpediment = async (DS_IMPEDITIVO : String) => {
    const response = await instance.put(BASE_URL, {
        DS_IMPEDITIVO: DS_IMPEDITIVO
    })

    return response.data
}

export const updateImpediment = async (data: UpdateImpedimentProps) => {
    const response = await instance.patch(BASE_URL, data)

    return response.data
}

export const deleteImpediment = async (props: DeleteImpedimentProps) => {
    const response = await instance.delete(BASE_URL, {
        data: props,
    })

    return response.data
}